import { Colors } from '@/common/colors/colors';
import ActionButton from '@/common/components/buttons/ActionButton';

const ActionButtons = ({ hook }) => {
	return (
		<>
			{hook.showSendInstructionsButton && (
				<ActionButton
					onClick={() => hook.setShowInstructions(true)}
					color={Colors.orange}
					defaultText={'Send instructions'}
				/>
			)}
			<ActionButton
				onClick={() => hook.handleSendTargets()}
				color={Colors.orange}
				defaultText={'Send targets'}
			/>
			{hook.showSendDocsButton && (
				<ActionButton
					onClick={() => hook.setShowDocs(true)}
					color={Colors.orange}
					defaultText={'Send docs'}
				/>
			)}
			<ActionButton
				onClick={() => hook.setShowAccept(true)}
				color={Colors.green}
				defaultText={'Accept'}
			/>
			<ActionButton
				onClick={() => hook.setShowAreYouSure(true)}
				defaultText={'Reject'}
				color={Colors.red}
			/>
		</>
	);
};

export default ActionButtons;
